// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_ny-0";